import React, { useRef } from "react";
import {
  TextInput,
  Grid,
  Select,
  Group,
  Checkbox,
  NumberInput,
} from "@mantine/core";
import { useForceUpdate } from "@mantine/hooks";
import RemoteSelect2 from "./remoteSelect2";
import { DATA_ITEM_ASSIGN_METHOD } from "../data/options";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import _ from "lodash";

export const AssignTeamMemberRow = ({ item }) => {
  const forceUpdate = useForceUpdate();

  const remoteRef = useRef(null);
  useDeepCompareEffect(() => {
    // console.log("item changed", item);
    forceUpdate();
    remoteRef.current?.refresh();
  }, [item]);

  return (
    <Group>
      <TextInput
        value={item.content["roleName"]}
        onChange={(e) => {
          item.content["roleName"] = e.currentTarget.value;
          forceUpdate();
        }}
      />
      {/* {item.content["user"]} */}
      <RemoteSelect2
        ref={remoteRef}
        apiEntity="user"
        labelField="name"
        valueField="_id"
        labelRender={(data) => `${data.aliasName} (${data.staffId ?? " -- "})`}
        multiple={false}
        searchFields={["name", "aliasName", "staffId"]}
        placeholder="Staff"
        clearable={true}
        value={item.content["user"]}
        onDataChange={(data) => {
          // console.log("AssignTeamMemberRow onDataChange", data);
          item.content["user"] = data ? data._id : null;
          // forceUpdate();
        }}
        sort={{
          by: "name",
          order: "asc",
        }}
      />
      {/* user:{item.content["user"]} */}
      {item.content.user === null && (
        <>
          <NumberInput
            placeholder={"No. Staff"}
            defaultValue={1}
            value={item.content["quantity"]}
            onChange={(n) => {
              item.content["quantity"] = n;
              forceUpdate();
            }}
          />
        </>
      )}
    </Group>
  );
};
